var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0H0V10H10V0Z",
    fill: "#001350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10L22 10L22 0L12 -4.4929e-10L12 10Z",
    fill: "#4F8CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H0V22H10V12Z",
    fill: "#001350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22L22 22L22 12L12 12L12 22Z",
    fill: "#001350"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioActive);
export default __webpack_public_path__ + "static/media/portfolio-active.6be38e570b251dddd7e2746202a8377c.svg";
export { ForwardRef as ReactComponent };